var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_2942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6852 1.81426C10.4683 1.71528 10.2325 1.66406 9.99403 1.66406C9.75552 1.66406 9.5198 1.71528 9.30281 1.81426L2.16575 5.06217C2.01797 5.12733 1.89232 5.23405 1.80412 5.36935C1.71591 5.50464 1.66895 5.66267 1.66895 5.82418C1.66895 5.98568 1.71591 6.14371 1.80412 6.279C1.89232 6.4143 2.01797 6.52102 2.16575 6.58618L9.31113 9.84241C9.52813 9.94139 9.76385 9.99262 10.0024 9.99262C10.2409 9.99262 10.4766 9.94139 10.6936 9.84241L17.839 6.59451C17.9867 6.52935 18.1124 6.42262 18.2006 6.28733C18.2888 6.15204 18.3358 5.99401 18.3358 5.8325C18.3358 5.67099 18.2888 5.51297 18.2006 5.37768C18.1124 5.24238 17.9867 5.13566 17.839 5.0705L10.6852 1.81426Z",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.99219C1.66562 10.1515 1.71092 10.3075 1.79653 10.4419C1.88214 10.5762 2.00448 10.6831 2.14904 10.75L9.31108 14.0063C9.52695 14.104 9.76118 14.1546 9.99814 14.1546C10.2351 14.1546 10.4693 14.104 10.6852 14.0063L17.8306 10.7584C17.978 10.6921 18.1029 10.5844 18.1902 10.4483C18.2774 10.3123 18.3232 10.1538 18.3219 9.99219",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 14.1562C1.66562 14.3155 1.71092 14.4716 1.79653 14.6059C1.88214 14.7402 2.00448 14.8472 2.14904 14.9141L9.31108 18.1703C9.52695 18.2681 9.76118 18.3186 9.99814 18.3186C10.2351 18.3186 10.4693 18.2681 10.6852 18.1703L17.8306 14.9224C17.978 14.8562 18.1029 14.7484 18.1902 14.6124C18.2774 14.4764 18.3232 14.3179 18.3219 14.1562",
    stroke: "white",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_2942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9871,
    height: 19.9871,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherManagement);
export default __webpack_public_path__ + "static/media/other_management.7d1ecc261bdccc9d89e5f431067c5d9b.svg";
export { ForwardRef as ReactComponent };